import { TableColumnsType } from "antd";
import TableUi from "../../../../../atoms/Table";
import Filters from "./Components/Filters";
import { useState } from "react";

export default function JobCosting() {
  const [pagination, setPagination] = useState(1);
  const [limit, setLimit] = useState(10);
  const [archived, isArchived] = useState(false);
  const [selectedRowKeys, setSelectedRowKeys] = useState<
    React.Key[] | string[]
  >([]);

  const [filters, setFilters] = useState<{
    type: undefined | string;
    status: undefined | string[];
    state: undefined;
    city: undefined;
    last_user_activity: string[] | undefined;
    onboarding_complete_date: string[] | undefined;
    search_text: undefined | string;
  }>({
    type: undefined,
    status: undefined,
    state: undefined,
    city: undefined,
    last_user_activity: undefined,
    onboarding_complete_date: undefined,
    search_text: undefined,
  });

  const columns: TableColumnsType = [
    {
      title: "Direct cost",
      dataIndex: "direct_cost",
      width: 240,
      render: (text) => (text ? text : "-"),
      sorter: (a, b) => a?.direct_cost?.localeCompare(b?.direct_cost),
    },
    {
      title: "Unit cost",
      dataIndex: "unit_cost",
      width: 120,
      render: (text) => (text ? text : "-"),
      fixed: "left",
      align: "right",
      sorter: (a, b) => a?.unit_cost?.localeCompare(b?.unit_cost),
      className: "right-aligned-sorter",
    },
    {
      title: "Estimated",
      dataIndex: "est_hrs_qty",
      width: 150,
      render: (text) => (text ? text : "-"),
      align: "right",
      className: "right-aligned-sorter",
      sorter: (a, b) => a?.est_hrs_qty?.localeCompare(b?.est_hrs_qty),
    },
    {
      title: "Projected",
      dataIndex: "projected_qty",
      width: 160,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",

      sorter: (a, b) => a?.projected_qty?.localeCompare(b?.projected_qty),
    },
    {
      title: "To date",
      dataIndex: "to_date_hrs_qty",
      width: 160,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",

      sorter: (a, b) => a?.to_date_hrs_qty?.localeCompare(b?.to_date_hrs_qty),
    },
    {
      title: "Est. cost",
      dataIndex: "est_cost",
      width: 120,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.est_cost?.localeCompare(b?.est_cost),
    },
    {
      title: "Projected cost",
      dataIndex: "projected_cost",
      width: 150,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.projected_cost?.localeCompare(b?.projected_cost),
    },
    {
      title: "To date cost",
      dataIndex: "to_date_cost",
      width: 150,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.to_date_cost?.localeCompare(b?.to_date_cost),
    },
    {
      title: "Total price",
      dataIndex: "total_price",
      width: 120,
      render: (text) => (text ? text : "-"),
      className: "right-aligned-sorter",
      align: "right",
      sorter: (a, b) => a?.total_price?.localeCompare(b?.total_price),
    },
    {
      title: "Project GM, %",
      dataIndex: "project_gm",
      width: 150,
      render: (text) => (text ? text : "-"),
      align: "right",
      className: "right-aligned-sorter",
      sorter: (a, b) => a?.project_gm?.localeCompare(b?.project_gm),
    },
  ];

  const dummyArray = [
    {
      direct_cost: "Man-hours",
      unit_cost: "",
      est_hrs_qty: "50:00",
      actual_hrs_qty: "49:50",
      to_date_hrs_qty: "3:50",
      est_cost: "$1,500",
      actual_cost: "$1,495",
      to_date_cost: "$115",
      total_price: "$2,419",
      project_gm: "38%",
    },
    {
      direct_cost: "Team B - Carlos E.",
      unit_cost: "$30/hr",
      est_hrs_qty: "50:00",
      actual_hrs_qty: "49:50",
      to_date_hrs_qty: "3:50",
      est_cost: "$1,500",
      actual_cost: "$1,495",
      to_date_cost: "$115",
      total_price: "$2,419",
      project_gm: "38%",
    }
  ];

  return (
    <div className="workOrderMaterial">
      <h3 style={{ position: "absolute", top: "10px" }}> Job Costing </h3>
      <TableUi
        columns={columns}
        data={{
          count: dummyArray?.length,
          data: dummyArray || [],
        }}
        filters={
          <Filters
            setFilters={setFilters}
            filters={filters}
            archived={archived}
            isArchived={isArchived}
          />
        }
        pageSize={limit}
        setPageSize={setLimit}
        setCurrentPage={setPagination}
        currentPage={pagination}
        selectedRowKeys={selectedRowKeys}
        setSelectedRowKeys={setSelectedRowKeys}
      />
    </div>
  );
}
